module.exports = __webpack_public_path__ + "img/bkllogotext240x80.1ef9508e.png";